import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { toNano, beginCell } from '@ton/core';
// Import TonConnect for wallet integration
import { useTonConnectUI, useTonWallet, TonConnectButton } from '@tonconnect/ui-react';

const ContractInteraction = () => {
  const [contractAddress, setContractAddress] = useState('EQBPZgdexsxqkjTfMHnF1HTaVbHH0Qceu1B0J_9k4Bn2UZlQ');
  const [userId, setUserId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [transactionStatus, setTransactionStatus] = useState('');

  // Use TonConnect for wallet integration
  const [tonConnectUI] = useTonConnectUI();

  const wallet = useTonWallet();
  const connected = !!wallet;
  const account = wallet?.account;


  const registerWithContract = async () => {
    setIsLoading(true);
    setTransactionStatus('Preparing transaction...');

    try {
      if (!connected || !account) {
        setTransactionStatus('Error: Please connect your wallet first');
        setIsLoading(false);
        return;
      }

      // Create BOC payload with comment "register"
      const payloadCell = beginCell().storeUint(0, 32).storeStringTail("register").endCell();
      const payloadBase64 = payloadCell.toBoc().toString('base64');

      // Prepare transaction
      const transaction = {
        validUntil: Math.floor(Date.now() / 1000) + 60, // valid for 60s
        messages: [
          {
            address: contractAddress,
            amount: toNano('0.1').toString(), // 0.1 TON
            payload: payloadBase64,
          }
        ]
      };

      // Send transaction
      const sendResult = await tonConnectUI.sendTransaction(transaction);
      console.log('Transaction result:', sendResult);

      setTransactionStatus(`✅ Registration successful! TX sent.`);
    } catch (error) {
      console.error('Error sending transaction:', error);
      setTransactionStatus(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const clearForm = () => {
    setContractAddress('');
    setUserId('');
    setTransactionStatus('');
  };

  return (
    <div className="contract-container">
      <div className="contract-content">
        <h1 className="contract-title">Register with Contract</h1>
        <p className="contract-description">
          Connect your wallet and register with the smart contract
        </p>

        <div className="contract-form">
          {/* Wallet Connection */}
          <div className="wallet-status">
            {connected ? (
              <div className="wallet-connected">
                <span className="status-indicator connected"></span>
                <span>Wallet Connected: {account?.address?.slice(0, 8)}...{account?.address?.slice(-8)}</span>
                <button
                  onClick={() => tonConnectUI.disconnect()}
                  className="disconnect-button"
                  style={{
                    backgroundColor: '#dc3545',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    marginLeft: '10px',
                    fontSize: '0.9rem'
                  }}
                >
                  Disconnect
                </button>
              </div>
            ) : (
              <div className="wallet-disconnected">
                <span className="status-indicator disconnected"></span>
                <span>Connect your wallet to continue</span>
                <TonConnectButton />
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="contractAddress">Contract Address:</label>
            <input
              type="text"
              id="contractAddress"
              value={contractAddress}
              onChange={(e) => setContractAddress(e.target.value)}
              placeholder="Enter contract address"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="userId">User ID:</label>
            <input
              type="number"
              id="userId"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="Enter your user ID"
              className="form-input"
              min="0"
              required
            />
          </div>

          <div className="form-actions">
            <button
              onClick={registerWithContract}
              disabled={isLoading || !connected || !userId.trim()}
              className="register-button"
            >
              {isLoading ? 'Processing...' : !connected ? 'Connect Wallet First' : !userId.trim() ? 'Enter User ID' : 'Register'}
            </button>

            <button
              onClick={clearForm}
              disabled={isLoading}
              className="clear-button"
            >
              Clear
            </button>
          </div>
        </div>

        {transactionStatus && (
          <div className={`transaction-status ${transactionStatus.includes('Error') ? 'error' : 'success'}`}>
            <p>{transactionStatus}</p>
          </div>
        )}

        <div className="navigation-section">
          <Link to="/wallet" className="nav-button wallet-button">
            Wallet Settings
          </Link>
          <Link to="/" className="nav-button home-button">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContractInteraction; 